/**
 * Legacy Stage 5 route — DSS Phase B: no second calculator.
 * Redirect to Results (or Recipe if nothing finalized yet).
 */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useAppSelector } from '../hooks/reduxHooks';

const UnifiedCalculatorPage: React.FC = () => {
  const navigate = useNavigate();
  const { calculationResults, stockSolution } = useAppSelector(
    (s) => s.workflow
  );

  useEffect(() => {
    const hasRecipe =
      Boolean(calculationResults) ||
      Boolean((stockSolution as any)?.calculationResult?.saltAmounts?.length);

    if (hasRecipe) {
      navigate('/results', { replace: true });
    } else {
      navigate('/stock-solutions', { replace: true });
    }
  }, [calculationResults, stockSolution, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '40vh',
        gap: 2,
      }}
    >
      <CircularProgress size={28} />
      <Typography variant="body2" color="text.secondary">
        Opening results…
      </Typography>
    </Box>
  );
};

export default UnifiedCalculatorPage;
